import { useIsViewer } from 'src/gql';
import { useGetEditorUserState } from 'src/hooks';
import { useEditingDisabled } from 'src/store/document/selectors';

export function useSpellcheckAvailable(): boolean {
  const { isInSigningCeremony, isReadOnly } = useGetEditorUserState();
  const editingDisabled = useEditingDisabled();
  const isViewer = useIsViewer();

  return !isInSigningCeremony && !isReadOnly && !editingDisabled && !isViewer;
}
